import { useEffect, useState } from "react";
import BottomMenuCasino from "../components/BottomMenuCasino";
import CommunityPageHeader from "../components/CommunityPageHeader";
import UserImagesContainer from "../components/UserImagesContainer";

import '../css/user_images_page.css'
import restApiHost from "..";
import { changeUserImageRequest } from "../helpers/requests";
import { useNavigate } from "react-router-dom";


function UserImagesPage({activeSubcategory, setActiveSubcategory, countryName, activeCommunitySubcategory, setActiveCommunitySubcategory, phoneNumber, userImage, userId, setUserImage}) {
    const [images, setImages] = useState([])
    const [activeImageId, setActiveImageId] = useState(null);
    const navigate = useNavigate()

    useEffect(() => {
        setActiveSubcategory('Сообщество');
        setActiveCommunitySubcategory('Чат')
    })
    useEffect(() => {
        async function fetchImages() {
            const response = await fetch(restApiHost + '/api/get-images/');
            const data = await response.json();
            setImages(data.images);
        }
        fetchImages();
    }, [])

    function changeUserImage() {
        if (activeImageId !== userImage?.id){
            changeUserImageRequest(userId, activeImageId);
            const foundImage = images.find(image => image.id === activeImageId);
            setUserImage({
                id: activeImageId,
                image: foundImage.image,
            })
            navigate(`/profile?phone=${phoneNumber}`)
        }
        else {
            navigate(`/profile?phone=${phoneNumber}`)
        }
    };

    
    return <div className="user-images-page">
        <CommunityPageHeader countryName={countryName} activeCommunitySubcategory={activeCommunitySubcategory} setActiveCommunitySubcategory={setActiveCommunitySubcategory} phoneNumber={phoneNumber}/>
        <UserImagesContainer images={images} userImage={userImage} activeImageId={activeImageId} setActiveImageId={setActiveImageId}/>
        <div className="save-user-image-button" onClick={changeUserImage}>
            <div className="save-user-image-button-text">{countryName === 'russia' ? 'СОХРАНИТЬ' : 'SAVE'}</div>
        </div>
        <BottomMenuCasino activeSubcategory={activeSubcategory} setActiveSubcategory={setActiveSubcategory} countryName={countryName} phoneNumber={phoneNumber}/>
    </div>
};

export default UserImagesPage;